import { Card, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  callAPI,
  clearRequest,
  getLocalValue,
  LoacalVariables,
  Method
} from "../../../commonFunctions/CommonFunctions";
import {
  HeaderList,
  IHeaderListActions
} from "../../../Components/Header/HeaderList";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import { WSIcons } from "../../../commonFunctions/iIcons";

export const LoyaltyRule: React.FC<any> = React.memo((props) => {
  const { control, handleSubmit, setValue } = useForm();
  const navigate = useNavigate();

  const params = useParams();
  const id = params?.id;
  const { showMessage } = useSnackbar();

  useEffect(() => {
    async function getLoyaltyRuleById(id: any) {
      try {
        const response: any = await callAPI(
          "LoyaltyRule",
          Method.GET,
          null,
          id
        );

        if (response) {
          setValue("pointsPerAmount", response.pointsPerAmount);
          setValue("redeemValuePerPoint", response.redeemValuePerPoint);
          setValue("referralBonusPoints", response.referralBonusPoints);
          setValue("expiryDays", response.expiryDays);
        }
      } catch (error) {
        console.error("failed to retrieve data", error);
        showMessage("Something went wrong. Please try again.", "error");
      }
    }
    if (id) {
      getLoyaltyRuleById(id);
    }
  }, [id, setValue]);

  const handleCancelClick = () => {
    navigate("/loyalty/rules");
  };

  /**
   * Method for Add/Update the data
   * @param data
   */

  const handleData = async (data: any) => {
    try {
      let request = {
        pointsPerAmount: data.pointsPerAmount,
        redeemValuePerPoint: data.redeemValuePerPoint,
        referralBonusPoints: data.referralBonusPoints,
        expiryDays: data.expiryDays
      };

      const newRequest = clearRequest(request);

      const endpoint = id ? `LoyaltyRule/${id}` : "LoyaltyRule";

      const method = id ? Method.PUT : Method.POST;

      const response: any = await callAPI(endpoint, method, newRequest);

      if (response && id) {
        showMessage("Loyalty Updated Successfully", "success");
        navigate("/loyalty/rules");
      } else {
        showMessage("Loyalty Created Successfully", "success");
        navigate("/loyalty/rules");
      }
    } catch (e: any) {
      showMessage(e.message, "error");
    }
  };

  const actions: IHeaderListActions[] = [
    {
      type: "icon",
      text: "Cancel",
      size: "small",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "error",
      icon: <WSIcons.CancelIcon />
    },
    {
      type: "icon",
      text: "Save",
      size: "small",
      buttonType: "submit",
      variant: "outlined",
      color: "success",
      icon: <WSIcons.SaveIcon />
    }
  ];

  return (
    <>
      <form onSubmit={handleSubmit(handleData)}>
        <HeaderList title="Add Loyalty Rules" type="card" actions={actions} />
        <Card sx={{ padding: 2, borderRadius: 2 }}>
          <Grid
            item
            container
            spacing={1}
            justifyContent={"start"}
            sx={{
              marginTop: 0,
              marginLeft: 0,
              width: "100%",
              backgroundColor: "#7D79C2",
              borderTopLeftRadius: 5,
              borderTopRightRadius: 5
            }}
          >
            <Grid
              alignContent={"center"}
              style={{ paddingLeft: 20, paddingTop: 0, height: "3rem" }}
              item
              sm={4}
              className="ws-data-grid-lightviolet-title"
            >
              <Typography
                variant="h6"
                id="tableTitle"
                sx={{ fontSize: "1rem" }}
              >
                Loyalty Rules
              </Typography>
            </Grid>
          </Grid>
          <Grid
            sx={{
              padding: 3,
              backgroundColor: "#fff",
              borderBottomLeftRadius: 5,
              borderBottomRightRadius: 5,
              border: "1px solid lightgrey"
              // marginTop: 3,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"PointsPer Amount"}
                  rules={{ required: "PointsPer Amount is required" }}
                  id="pointsPerAmount"
                  name="pointsPerAmount"
                  control={control}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Redeem Value Per Point"}
                  rules={{ required: "Redeem Value is required" }}
                  id="redeemValuePerPoint"
                  name="redeemValuePerPoint"
                  control={control}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Referrel Bonus Points"}
                  rules={{ required: "Referrel Bonus Points is required" }}
                  id="referralBonusPoints"
                  name="referralBonusPoints"
                  control={control}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Expiry Days"}
                  rules={{ required: "Expiry Days is required" }}
                  id="expiryDays"
                  name="expiryDays"
                  control={control}
                  type={TextType.Number}
                />
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </form>
    </>
  );
});
